import { render, staticRenderFns } from "./PelatihanEvaluasiPenyelenggaraan.vue?vue&type=template&id=3391555d"
import script from "./PelatihanEvaluasiPenyelenggaraan.vue?vue&type=script&lang=js"
export * from "./PelatihanEvaluasiPenyelenggaraan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports